<template>
    <div class="relative flex w-full">
        <select class="bg-grey-light border-r-0 border-b-2 border-l-2 border-t-2 form-select rounded-r-none"
                v-if="!disabled"
                v-model="cleaveOptions.phoneRegionCode"
                @change="updateRegion">
            <option v-for="region in regions" :value="region.code">{{ region.code }}</option>
        </select>

        <cleave type="tel"
                ref="input"
                inputmode="tel"
                :options="cleaveOptions"
                v-model="currentValue"
                v-bind="attrs"
                :disabled="disabled"
                :class="{'border-l-0 rounded-l-none': !disabled}"
                class="block border-2 flex-1 focus:border-green form-input"
        />
    </div>
</template>
<script>
import Cleave from 'vue-cleave-component';
import countries from "../countries";
import {nextTick, reactive, ref} from 'vue';

export default {
    inheritAttrs: false,
    props: {
        type: {
            type: String,
            default: 'text',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: '+41'
        }
    },
    components: {
        Cleave
    },
    setup({value, disabled, type}, {attrs}) {
        if (value.length === 0) {
            value = '+41';
        }
        let currentValue = ref(value);
        const input = ref(null);

        let regions = countries().sort((a, b) => a.code.localeCompare(b.code));
        let getRegionByPrefix = (phoneNumber) => {
            for (let i = 0; i < regions.length; i++) {
                if (phoneNumber.startsWith(regions[i].prefix)) {
                    return regions[i];
                }
            }

            return regions[0];
        }
        let getRegionByCode = (code) => {
            for (let i = 0; i < regions.length; i++) {
                if (code === regions[i].code) {
                    return regions[i];
                }
            }

            return regions[0];
        }

        let cleaveOptions = reactive({
            phone: true,
            phoneRegionCode: getRegionByPrefix(value).code,
            prefix: '+'
        });

        let updateRegion = (event) => {
            nextTick(() => {
                currentValue.value = getRegionByCode(event.target.value).prefix;
            })
        }

        return {
            cleaveOptions,
            regions,
            disabled,
            currentValue,
            attrs,
            input,
            updateRegion,
        }
    },
}
</script>
